import { styled as muiStyled } from '@mui/material';


import { makeSxProps, SxPropsParam } from 'lib/mui-util';



interface Props {
    src: string;
    alt?: string;
    width?: number;
    height?: number;
    sx?: SxPropsParam;
}

const ImageElement = muiStyled('img')({
});

export default function PageImage(props: Props) {
    return <ImageElement 
        src={props.src} 
        alt={props.alt ?? props.src} 
        sx={[...makeSxProps(props.sx), {
            width: props.width,
            height: props.height,
        }]}
    />
}

